import { axiosStudentInstance } from "./studentAuth"

export type LearnerNotification = {
  id: string
  title: string
  message?: string | null
  notification_type?: string
  data?: Record<string, unknown> | null
  created_at?: string
  is_read?: boolean
}

/** Socket + persisted learner notification when AI practice-paper gen finishes. */
export const QUESTION_GENERATION_COMPLETE = "question_generation_complete"

/** Socket + persisted learner notification when marking finishes. */
export const ASSESSMENT_COMPLETE = "assessment_complete"

export const getStudentNotifications = () =>
  axiosStudentInstance.get<{ data: LearnerNotification[] }>("/notifications/")

export const markStudentNotificationRead = (id: string) =>
  axiosStudentInstance.post(`/notifications/${id}/read/`)

export const markAllStudentNotificationsRead = () =>
  axiosStudentInstance.post("/notifications/read-all/")
